import { Button, CardContent, Checkbox, CircularProgress, Divider, FormControlLabel, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import NumberFormat from "../custom/Number";
import { connect } from "react-redux";
import { compose } from "redux";
import { Field, reduxForm } from "redux-form";
import * as actions from "../actions";
import { approveContractAgent } from "../actions";
import FormDialog from "../custom/FormDialog";
import HeaderPageItem from "../custom/HeaderPageItem";
import InfoItem from "../custom/InfoItem";
import PageContainer, { CardPageItem } from "../custom/Page";
import ContractAgentDescription from "./components/ContractAgentDescription";
import DateFormatter from "./components/DateFormatter";
import DisplayPermissionsDialog from "./components/Management/Dialogs/DisplayPermissions";
import { AgreementLevelName } from "../util";
import PermissionsInfo from "./components/PermissionInfo";
import UsersAbove from "./components/UsersAbove";
import { ContractAgentByUser } from "./components/ContractAgentByUser";

function FormCheckbox({ input, label, ...props }) {
  return (
    <Checkbox
      label={label}
      checked={input.value ? true : false}
      onChange={input.onChange}
      {...props}
    />
  );
}
class ContractAgentDetail extends Component {
  state = {
    contractConfirmed: false,
    contractDetail: false,
    openPermissionDialog: false,
    yesOrNo: false,
    btn: true,
  };

  approveContract = () => {
    const { onActionComplete, showErrorMessage, showSuccessMessage, history, currentUser } = this.props;
    approveContractAgent()
      .then((response) => {
        showSuccessMessage("app.contractAgent.confirmed");

        history.push("/contracts");
        window.location.reload(false);
      })
      .catch((e) => {
        if (e.response) {
          showErrorMessage(e.response.data.message);
        } else {
          showErrorMessage(e);
        }
      });
  };

  render() {
    const { currentUser } = this.props;
    const { contractAgent } = currentUser;
    const { levelName } = contractAgent.contractAgentClass;

    if (!currentUser) {
      return <CircularProgress style={{ marginTop: "25%" }} />;
    } else {
      return (
        <PageContainer>
          <HeaderPageItem
            title="app.contractAgent.title.overview"
            showBackButton
            destination="/contracts"
          />
          <CardPageItem raised>
            <CardContent>
              {contractAgent.status === "PENDING" ? (
                <>
                  <Typography
                    color="primary"
                    variant="h6"
                  >
                    <FormattedHTMLMessage id="app.contractAgent.approve" />
                  </Typography>
                </>
              ) : (
                <Typography
                color="primary"
                variant="h6"
                >
                  <FormattedMessage id="app.contract.details" />
                </Typography>
              )}
              <Divider />
              <br />
              <InfoItem
                caption={<FormattedMessage id="app.name" />}
                text={`${currentUser.name} (${currentUser.id})`}
                />

              <InfoItem
                caption={<FormattedMessage id={`app.enuns.${contractAgent.status}`} />}
                text={
                  <>
                    <FormattedMessage id="app.contractAgent.signed" />
                    {currentUser.contractAgent.status === "ACTIVE" ? (
                      <DateFormatter
                      date={contractAgent.signatureDate}
                      format={currentUser.locale}
                      />
                    ) : (
                      <FormattedMessage id="app.enuns.PENDING" />
                    )}
                  </>
                }
              />
              <InfoItem
                caption={<FormattedMessage id="app.manager.userLevel" />}
                text={
                  <>
                    <FormattedMessage id={`app.enuns.levelName.${levelName}`} />
                  </>
                }
              />

              {levelName !== AgreementLevelName.AGENT && (
                <InfoItem
                  caption={<FormattedMessage id="app.manager.jobTitle" />}
                  text={contractAgent?.jobTitle ?? <FormattedMessage id="app.enuns.AGENT" />}
                />
              )}

              {levelName === AgreementLevelName.AGENT_MANAGER && (
                <InfoItem
                  caption={<FormattedMessage id="app.manager.managerMonthlyCommission" />}
                  text={
                    <NumberFormat
                      value={contractAgent.managerMonthlyCommission}
                      display={"percentage"}
                      hideValue={currentUser.hideValues}
                    />
                  }
                />
              )}

              {[AgreementLevelName.REGIONAL_MANAGER, AgreementLevelName.SALES_DIRECTOR, AgreementLevelName.CCO].includes(levelName) && (
                <>
                  <InfoItem
                    caption={<FormattedMessage id="app.manager.managerOneTimeCommission" />}
                    text={
                      <NumberFormat
                        value={contractAgent.managerOneTimeCommission}
                        display={"percentage"}
                        hideValue={currentUser.hideValues}
                      />
                    }
                  />
                  <InfoItem
                    caption={<FormattedHTMLMessage id="app.manager.visibility" />}
                    text={<FormattedHTMLMessage id={`app.manager.visibility.${contractAgent.visibilityPermission}`} />}
                  />
                </>
              )}

              {[AgreementLevelName.AGENT_MANAGER, AgreementLevelName.REGIONAL_MANAGER, AgreementLevelName.SALES_DIRECTOR, AgreementLevelName.CCO].includes(levelName) && (
                <InfoItem
                  caption={<FormattedHTMLMessage id="app.manager.permissions" />}
                  text={
                    <PermissionsInfo
                      permissions={contractAgent.permissions}
                      handleOpenDialog={() => this.setState({ openPermissionDialog: true })}
                    />
                  }
                />
              )}
            </CardContent>
          </CardPageItem>

          <CardPageItem raised>
            <CardContent>
              <Typography
                color="primary"
                variant="h6"
              >
                <FormattedHTMLMessage id="app.contractAgent.title.fullText" />
              </Typography>
              <Divider />
              <br />
              <Button
                fullWidth
                variant="outlined"
                onClick={() => this.setState({ contractDetail: true })}
              >
                <FormattedHTMLMessage id="app.contractAgent.button.fullText" />
              </Button>
            </CardContent>
          </CardPageItem>

          <UsersAbove
            user={currentUser}
            renderDivider
            title={"app.managers.above"}
            titleAlign={"inherit"}
            titleColor={"primary"}
            titleVariant={"h6"}
          />

          <FormDialog
            title={`app.contractAgent.readAgreement.${currentUser?.contractAgent?.contractAgentClass?.levelName}`}
            open={this.state.contractDetail}
            variant="secondary"
            onClose={(e) => this.setState({ contractDetail: false })}
          >
            <CardContent>
              <ContractAgentByUser user={currentUser} />
              {currentUser.contractAgent.status === "PENDING" && (
                <>
                  <FormControlLabel
                    label={<FormattedMessage id="app.withdrawTerms" />}
                    control={
                      <Field
                        component={FormCheckbox}
                        name="acceptReceipt"
                        color="primary"
                        disabled={false}
                        onChange={(e) => {
                          if (e.target.checked) {
                            this.setState({ btn: false });
                          } else {
                            this.setState({ btn: true });
                          }
                        }}
                      />
                    }
                  />
                  <Button
                    disabled={this.state.btn}
                    fullWidth
                    variant="contained"
                    color="primary"
                    style={{ marginTop: 16, marginBottom: 16 }}
                    onClick={(e) => {
                      this.approveContract();
                    }}
                  >
                    <FormattedMessage id="app.ok" />
                  </Button>
                </>
              )}
            </CardContent>
          </FormDialog>

          <DisplayPermissionsDialog
            handleCloseDialog={() => this.setState({ openPermissionDialog: false })}
            open={this.state.openPermissionDialog}
            user={currentUser}
          />
        </PageContainer>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.user.user.me,
    clauses: state.contractAgent.clauses,
  };
}

export default compose(
  connect(mapStateToProps, actions),
  reduxForm({
    form: "newContractAgent",
  })
)(ContractAgentDetail);
